export enum PaymentMethod {
  Cash = 1,
  Cheque = 2,
  CreditCard = 3,
  StandingOrder = 4,
  AccountTransfer = 5,
  DirectDebit = 6,
}
